'use strict';
import {
  CountUp
} from '../../../../../../../node_modules/countup.js/dist/countUp.min.js';
require("../vendor/jquery.waypoints.js");

// ES6 class definition
export default class TeaserCount {

  constructor() {
    this.language = 0;
    if(document.querySelector('.language')) {
      this.language = document.querySelector('.language').getAttribute("data-language");
    }
    if(this.language == 0) {
      this.separator = ".";
      this.decimal = ',';
    } else {
      this.separator = ',';
      this.decimal = '.';
    }

    this.options = {
      duration: 3,
      separator: this.separator,
      decimal: this.decimal,
    };
  }

  init() {
    let self = this;

    self.initCounting();

    $('.teaser__number').each(function () {
      let countingTeaser = $(this);
      new Waypoint({
        element: countingTeaser,
        handler: function (direction) {
          if (direction === "down") {
            self.initCounting(self, countingTeaser);
          }
        },
        offset: '95%'
      });
    });

    // animate teaser on scrolling
    $('.teaser__scroll').each(function () {
      let scrolledTeaser = $(this);
      new Waypoint({
        element: scrolledTeaser,
        handler: function (direction) {
          if (direction === "down") {
            scrolledTeaser.addClass('scrolled');
          }
        },
        offset: '95%'
      });
    });

    // animate reveal presentation on scrolling
    $('.ce-speech-scroll').each(function () {
      let scrollingElement = $(this);
      new Waypoint({
        element: scrollingElement,
        handler: function (direction) {
          if (direction === "down") {
            scrollingElement.addClass('show');
          }
        },
        offset: '95%',

      });
    });
  }

  initCounting(self, countingTeaser) {
    let countUp = new CountUp($(countingTeaser).attr('id'), $(countingTeaser).data('end'), this.options);
    countUp.start();
  }

}
